/**
 * @generated SignedSource<<f09588833a33d7f51101309a31bffc11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeletePayratesInput = {
  clientMutationId?: string | null | undefined;
  payrateIds: ReadonlyArray<string | null | undefined>;
};
export type DeletePayratesMutation$variables = {
  connections: ReadonlyArray<string>;
  input: DeletePayratesInput;
};
export type DeletePayratesMutation$data = {
  readonly deletePayrates: {
    readonly deletedPayrateIds: ReadonlyArray<string | null | undefined> | null | undefined;
    readonly errors: any | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type DeletePayratesMutation = {
  response: DeletePayratesMutation$data;
  variables: DeletePayratesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "success",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "deletedPayrateIds",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeletePayratesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePayratesPayload",
        "kind": "LinkedField",
        "name": "deletePayrates",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeletePayratesMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeletePayratesPayload",
        "kind": "LinkedField",
        "name": "deletePayrates",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteEdge",
            "key": "",
            "kind": "ScalarHandle",
            "name": "deletedPayrateIds",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "03d0e1c19f2217c2d0ad07089afdea18",
    "id": null,
    "metadata": {},
    "name": "DeletePayratesMutation",
    "operationKind": "mutation",
    "text": "mutation DeletePayratesMutation(\n  $input: DeletePayratesInput!\n) {\n  deletePayrates(input: $input) {\n    success\n    errors\n    deletedPayrateIds\n  }\n}\n"
  }
};
})();

(node as any).hash = "56869c1152314e725ed5274b65434098";

export default node;
